var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecretIdentity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D2607D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0005 29.9996C23.2848 29.9996 30.0005 23.2839 30.0005 14.9996C30.0005 12.4172 29.3479 9.98726 28.1987 7.86562C25.5617 5.56164 22.1108 4.16577 18.334 4.16577C10.0497 4.16577 3.33398 10.8815 3.33398 19.1658C3.33398 21.7481 3.98655 24.1781 5.13578 26.2998C7.77283 28.6037 11.2237 29.9996 15.0005 29.9996Z",
    fill: "#E0708E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_20781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9488 9.23927C21.92 9.03298 21.7716 8.86329 21.571 8.80751L15.1403 7.01914C15.0486 6.99362 14.9518 6.99362 14.86 7.01914L8.42935 8.80751C8.2287 8.86329 8.08028 9.03291 8.05155 9.23927C8.01425 9.50747 7.16336 15.8444 9.34584 18.9969C11.5257 22.1456 14.7416 22.9525 14.8774 22.9853C14.9177 22.9951 14.9589 22.9999 15.0002 22.9999C15.0414 22.9999 15.0826 22.995 15.1229 22.9853C15.2588 22.9525 18.4746 22.1456 20.6545 18.9969C22.8369 15.8445 21.9861 9.50754 21.9488 9.23927ZM19.1471 12.9389L14.7607 17.3252C14.6587 17.4273 14.5248 17.4784 14.391 17.4784C14.2573 17.4784 14.1234 17.4274 14.0213 17.3252L11.3093 14.6132C11.2112 14.5152 11.1561 14.3821 11.1561 14.2435C11.1561 14.1048 11.2113 13.9718 11.3093 13.8738L11.8478 13.3353C12.052 13.1311 12.3831 13.1311 12.5872 13.3353L14.391 15.1391L17.8692 11.6609C17.9672 11.5628 18.1002 11.5077 18.2389 11.5077C18.3776 11.5077 18.5106 11.5628 18.6086 11.6609L19.1471 12.1994C19.3513 12.4036 19.3513 12.7347 19.1471 12.9389Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_20781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretIdentity);
export default __webpack_public_path__ + "static/media/secret-identity.bdb6b5f8e53c8ed1f8a1d6fa626abe65.svg";
export { ForwardRef as ReactComponent };